import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useEntityScope } from './useEntityScope.js';

/**
 * Récupère l'arborescence complète flux → catégorie → items (4 modes).
 * Désactivé en vue groupe : les budgets/provisions/hypothèses se gèrent par
 * entité, l'agrégation n'a pas de sens fonctionnel.
 *
 * @param {object} [options]
 * @param {'active'|'past'} [options.scope='active'] — filtre temporel transmis au backend
 */
export function useForecastTree({ scope = 'active' } = {}) {
  const { isGroup } = useEntityScope();
  return useQuery({
    queryKey: ['forecasts', 'tree', scope],
    queryFn: () => api.get(`/forecasts/tree?scope=${scope}`),
    staleTime: 30_000,
    enabled: !isGroup,
  });
}
